import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-page">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-4">
            <i className="ri-compass-3-line"></i> 分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            探索你喜欢的 <span className="text-primary-500">漫画类型</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-lg mx-auto">
            八大分类满足你的所有口味，总有一个是你喜欢的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 hover:bg-background-200/70 rounded-xl p-5 md:p-6 flex flex-col items-center text-center cursor-pointer transition-all"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-950 font-semibold">{cat.name}</h3>
              <span className="text-xs text-foreground-500 mt-1">{cat.count} 部作品</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}